import { Project } from "@/models";

export const projectsData: readonly Project[] = [
  {
    name: "Bienestar a la Carta",
    description: "Bienestar a la Carta es una línea de solución de la Plataforma Integral de Bienestar de Compensar.",
    technologies: ["Javascript", "ReactJS", "Java"],
    url: "https://bienestaralacarta.com/",
  },
  {
    name: "changelogtxt-parser",
    description: "Changelogtxt-parser is a python api, CLI, and github action for parsing and verifying a changelog.txt",
    technologies: ["Python"],
    url: "https://pypi.org/project/changelogtxt-parser/",
  },
  {
    name: "container-tester",
    description: "Container-Tester is a small Python utility that helps you test your project on top of many different Linux distributions without having to run and maintain lots of Docker tests yourself.",
    technologies: ["Python"],
    url: "https://pypi.org/project/container-tester/",
  },
  {
    name: "curioso",
    description: "Curioso is a python api, CLI, for detecting operating system information and reporting in a JSON format.",
    technologies: ["Python"],
    url: "https://pypi.org/project/curioso/",
  },
];
